export enum NirvanaErrorCodeMessage {
  FORBIDDEN_RESOURCE = 'Forbidden resource',
  FEATURE_CURRENTLY_NOT_AVAILABLE = 'Feature currently not available',
}

export enum NirvanaErrorCode {
  UNKNOWN = 0,
  STREAM_CLOSED = 1,
  STREAM_ALREADY_OPEN = 2,
  STREAM_ID_INVALID = 3,
  STREAM_START_FAILED = 4,
  STREAM_NOT_READY = 5,
  CLIENT_RESPONSE_INVALID = 6,
  KEEP_ALIVE_FAILED = 7,
  GATEWAY_SHUTDOWN = 8,
  MQ_ERROR = 9,
  CLIENT_RESPONSE_ERROR = 10,
  INVALID_MESSAGE_TYPE = 11,
  INIT_TIMEOUT = 12,
  CLIENT_DISCONNECTED = 13,
  DUPLICATE_STREAM_ID = 14,
  ACCESS_DENIED = 15,
  SERVER_SHUTDOWN = 16,
  UNEXPECTED_STOP = 17,
  INVALID_MESSAGE = 18,
  INVALID_DATA = 19,
  USER_VALIDATION_ERROR = 20,
  ENDPOINT_VALIDATION_ERROR = 21,
  TWO_FACTOR_AUTHENTICATION_FAILED = 22,
  AUTHENTICATION_FAILED = 23,
  INVALID_METHOD_NAME = 24,
  SERVICE_NOT_FOUND = 25,
  METHOD_NOT_FOUND = 26,
  INVALID_SOCKET_ID = 27,
  REQUEST_TIMED_OUT = 28,
  SAME_USER_SAME_ENDPOINT_LIMIT_REACHED = 29,
  SAME_USER_MULTIPLE_ENDPOINTS_LIMIT_REACHED = 30,
  MULTIPLE_USERS_SAME_ENDPOINT_LIMIT_REACHED = 31,
  COMPANY_VALIDATION_ERROR = 32,
  TOO_MANY_REQUESTS = 33,
  FIX_END_SESSION_UNKNOWN = 34,
  FEATURE_CURRENTLY_NOT_AVAILABLE = 35,
  INVALID_SERVICE = 36,
  NOT_FOUND = 37,
  FEATURE_NOT_SUPPORTED = 38,
  REDIS_ERROR = 39,
  IDP_AUTH_FAILED = 40,
  CANNOT_PROCESS_REQUEST = 41,
}

export interface NirvanaSanitizedError {
  id: string;
  name: string;
  code: NirvanaErrorCode;
  message: string;
}

export const NirvanaErrorCodeValues = Object.values(NirvanaErrorCode);

export enum StreamExitCode {
  SUCCESS = 0,
  FAILED = 1,
}
